import React from "react";
import { useParams } from "react-router-dom";
import { SkeletonPet } from "../Pets/SkeletonPet";
import { NotFound } from "../../404NotFound/NotFound";
import { useGetPersonById } from "../../../hooks/Person/useGetPersonById";
import { getStringToBoolean } from "../../../utils/functions";
import { Person } from "./Person";
import { typeObject } from "../../../utils/constants";
import { NewQr } from "../../NewQr/NewQr";

export const ProfilePerson = () => {
  let { id } = useParams();
  const { data, isLoading } = useGetPersonById(id);

  const notFount = !isLoading && !data;
  const created = getStringToBoolean(data?.created);

  if (isLoading) return <SkeletonPet />;

  if (notFount) return <NotFound />;

  if (created) return <Person person={data || {}} />;

  if (!created) return <NewQr type={typeObject?.persons} />;
};
